import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';


const CadAiToolHandler = ({ renderCadAiMarks, clearCadAiMarks }) => {

    const currentTool = useSelector((state) => state.testView.currentTool);
    const cadAiHasRenderedOnce = useRef(false);

    useEffect(() => {
        if (currentTool === 'CadAi') {
            renderCadAiMarks(cadAiHasRenderedOnce.current);
            cadAiHasRenderedOnce.current = true;
        }else{
            cadAiHasRenderedOnce.current = false;
            clearCadAiMarks();
        }
    }, [currentTool, renderCadAiMarks,clearCadAiMarks ]);

    return null;
};

export default CadAiToolHandler;
